import Vue from 'vue'
import App from './App'
import router from './router'
import animate from "animate.css";
import 'lib-flexible'
import '@/utils/rem'
// import {$http} from '@/request/axiosHttp'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import './style/common.scss'
import './style/animate.css'
import 'babel-polyfill'
// 表单验证插件vee-validate
import './assets/js/validate'
import $ from 'jquery'

// 引入公用的function方法
import common from './lib/common.js';
Vue.prototype.common = common;

Vue.config.productionTip = false
// 定义全局axios
// Vue.prototype.$http=$http;
/* eslint-disable no-new */
Vue.use(animate)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js